var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinareLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "146.72,394.69 146.72,699.95 219.17,699.95 219.17,539.59 299.18,625.62 385.21,535.06 385.21,699.95    447.08,699.95 447.08,394.69 424.44,394.69 299.92,537.71 178.43,394.69  ",
    fill: "#ffffff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 497.27,
    y: 393.95,
    width: 70.57,
    height: 306.01,
    fill: "#ffffff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1775.81,274.33 822.12,274.33 822.12,333.59 822.12,340 822.12,569.76 687.42,435.06 646.3,393.95 645.77,393.95    616.88,393.95 616.88,422.84 616.88,455.25 616.88,740.7 143.53,740.7 143.53,806.33 687.42,806.33 687.42,748.99 687.42,740.7    687.42,525.82 822.12,660.52 861.55,699.95 868.97,699.95 892.69,699.95 892.69,676.24 892.69,640.33 892.69,340 1775.81,340  ",
    fill: "#ffffff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1529.35,699.92l-73.73-129.39c32.72-12.46,52.43-41.75,52.43-83.77c0-59.15-34.77-86.39-72.99-91.77   c-4.83-0.68-9.7-1.03-14.58-1.04h-153.91v305.97h67.92V575.4h45.48l70.94,124.52H1529.35z M1334.53,459.38h85.99   c9.61,0,27.91,5.61,27.91,27.38c0,20.36-12.97,26.37-31.84,26.37h-82.09L1334.53,459.38z",
    fill: "#ffffff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1110.45,393.95h-61.94L925.51,699.92h73.19l20.39-49.41h122.44l20.15,49.41h70.91L1110.45,393.95z M1040.65,584.57   l38.6-95.19l38.6,95.19H1040.65z",
    fill: "#ffffff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1615.04,575.13 1730.69,575.13 1730.69,513.16 1615.04,513.16 1615.04,459.41 1774.09,459.41 1774.09,393.95    1615.04,393.95 1588.64,393.95 1545.44,393.95 1545.44,699.65 1599.19,699.65 1615.04,699.65 1774.09,699.65 1774.09,635.59    1615.04,635.59  ",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinareLogoWhite);
export default __webpack_public_path__ + "static/media/Minare-logo-white.f39fc047d480a5408e11f7c4d2697dd2.svg";
export { ForwardRef as ReactComponent };